import {ReactElement, useState} from "react";
import {Navigation} from "components/UIComponents/Navigation";
import {FormattedMessage} from "react-intl";
import {PrimaryButton} from "components/UIComponents/PrimaryButton";
import {SubTitle} from "components/UIComponents/SubTitle";
import {ReactComponent as CloseIcon} from "components/Icons/close.svg";
import {AlgoliaWine} from "features/winepicker/winePickerModel";
import {WineScannerList} from "./WineScannerList";
import {WineScannerDetail} from "./WineScannerDetail";
import {UUID4} from "lib/api/wineScannerApi";
import {Language} from "features/i18n/translations";

export interface WineScannerPickerProps {
    onClose: () => void
    onPick: (pickedWines: AlgoliaWine[]) => void
    language: Language
}

type SubPage =
    | {type: 'list'}
    | {type: 'detail'; jobId: UUID4};

export function WineScannerPicker(props: WineScannerPickerProps): ReactElement {
    const [subPage, setSubPage] = useState<SubPage>({type: 'list'});
    const [pickedWines, setPickedWines] = useState<Record<string, AlgoliaWine>>({});

    const noPickedWines = Object.keys(pickedWines).length;

    const setWinePicked = (wine: AlgoliaWine, selected: boolean) => {
        setPickedWines(prev => {
            if (selected) {
                return {...prev, [wine.objectID]: wine};
            }
            const {[wine.objectID]: _, ...rest} = prev;
            return rest;
        });
    };

    const onPick = () => {
        props.onPick(Object.values(pickedWines));
        props.onClose();
    };

    return (
        <div className="w-full h-full flex flex-col items-stretch bg-white">
            <div className="flex-none">
                <Navigation
                    left={<>
                        <SubTitle><FormattedMessage id="winescannerpicker.navigation.title"/></SubTitle>
                    </>}
                    right={<>
                        <div className="flex-auto font-semibold py-4 leading-snug text-right">
                            {noPickedWines > 0 && (
                                <span className="flex-none">
                                    <FormattedMessage
                                        id="winepicker.results.noPickedWines"
                                        values={{noPicked: noPickedWines}}
                                    />
                                </span>
                            )}
                        </div>
                        {subPage.type === 'detail'&&<PrimaryButton onClick={onPick}>
                            <FormattedMessage id="winepicker.navigation.chose"/>
                        </PrimaryButton>}
                        <span/>
                        <button onClick={props.onClose}><CloseIcon/></button>
                    </>}
                />
            </div>

            {subPage.type === 'list' && (
                <WineScannerList onSelectJob={jobId => setSubPage({type: 'detail', jobId})}/>
            )}
            {subPage.type === 'detail' && (
                <WineScannerDetail
                    jobId={subPage.jobId}
                    language={props.language}
                    pickedWines={pickedWines}
                    onSetWinePicked={setWinePicked}
                />
            )}
        </div>
    );
}
